// Libraries
import I18n from 'i18next'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Link } from '@react-navigation/web'
import { Empty, Card, Skeleton } from 'antd'
import { get, defaultTo, isNil, isEmpty, map } from 'lodash'

// Resources
import { actions as scenarioActions } from 'Resources/ScenarioResource'

class InformationTab extends Component {
  static propTypes = {
    // DonnÃ©es de la vue
    scenario: PropTypes.object,
    title: PropTypes.string,

    // TÃ©moins d'activitÃ© API
    loading: PropTypes.bool
  }

  static defaultProps = {
    // DonnÃ©es de la vue
    scenario: {},

    // TÃ©moins d'activitÃ© API
    loading: false
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  /**
   * Rendu d'une ligne de d'information
   */
  renderRow = ({ format, visible = true, dataIndex }, key) => {
    const { loading, scenario } = this.props

    return (
      visible && (
        <Skeleton
          key={key}
          className='drawer-layout-description-item-skeleton'
          paragraph={false}
          loading={loading}
        >
          <p className='drawer-layout-description-item'>
            {/* Nom de la ligne */}
            <span className='drawer-layout-description-item-name'>
              {I18n.t(`pages.scenario.tabs.information.rows.${key}.title`)}
            </span>

            {/* Valeur de la ligne */}
            <span className='drawer-layout-description-item-value'>
              {!isNil(format)
                ? format(get(scenario, defaultTo(dataIndex, key)))
                : get(scenario, defaultTo(dataIndex, key))}
            </span>
          </p>
        </Skeleton>
      )
    )
  }

  render() {
    const { scenario, loading, title } = this.props

    // PrÃ©paration des informations Ã  afficher
    const informationRows = {
      // Date de dÃ©but
      startDate: {
        format: date =>
          moment(date).isValid() ? moment(date).calendar() : null
      },
      // Date de fin
      endDate: {
        format: date =>
          moment(date).isValid() ? moment(date).calendar() : null,
        visible: get(scenario, 'status') === 'done'
      },
      // Site
      site: {
        dataIndex: 'waterTank.site',
        format: site => (
          <Link routeName='Sites' params={defaultTo(get(site, 'id'), 0)}>
            {get(site, 'name')}
          </Link>
        )
      },
      // Taux d'application
      applicationRate: {
        format: applicationRate =>
          `${defaultTo(applicationRate, 0).toLocaleString()} l/min/mÂ²`
      },
      // DÃ©bit d'eau
      waterTotalFlow: {
        format: waterTotalFlow =>
          `${defaultTo(waterTotalFlow, 0).toLocaleString()} mÂ³/h`
      },
      // DÃ©bit de prÃ©-mÃ©lange
      mixTotalFlow: {
        format: mixTotalFlow =>
          `${defaultTo(mixTotalFlow, 0).toLocaleString()} mÂ³/h`
      },
      // DÃ©bit impactant la cuvette
      basinTotalFlow: {
        format: basinTotalFlow =>
          `${defaultTo(basinTotalFlow, 0).toLocaleString()} mÂ³/h`
      },
      // Concentration d'Ã©mulseur
      emulsifierRate: {
        format: emulsifierRate =>
          `${defaultTo(emulsifierRate, 0).toLocaleString()} %`
      }
    }

    return (
      <Card title={title} loading={loading} className='tab information'>
        {isEmpty(scenario) ? <Empty /> : map(informationRows, this.renderRow)}
      </Card>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(InformationTab, 'defaultProps', {})

  return {
    scenario: defaultTo(get(state, 'scenario.item'), defaultProps.scenario)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...scenarioActions }, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InformationTab)
